import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { GoUnverified } from 'react-icons/go';
import { getContent } from '../api';

export default function Page404() {
  const { t } = useTranslation();
  const history = useHistory();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    getContent()
      .then((res) => {
        setLogo(res.data.main[1].image);
      })
      .catch();
  }, []);

  return (

    <>
      <button type="button" className="go-back-button" onClick={() => { history.goBack(); }}>
        {t('goBack')}
      </button>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" className="mx-2" />
      </div>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <h1 className="my-auto font-weight-bold title-404 text-center title">{t('pageNotFound')}</h1>
      </div>
      <div className="text-center">
        <GoUnverified size="70px" />
      </div>
      <div className="text-center mt-5">
        <a href="/">
          <button type="button" className="green-button">HomePage</button>
        </a>
      </div>
    </>
  );
}
